"use client"

import React from 'react';
import Minicart from './minicart/renderer';
import Menu from './menu/renderer';
import logo from '../../../public/static/images/icon_white.svg';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import '../../styles/2-layout/_3-navigation.scss';

export default function Header () {
    return <div className="header-wrapper bg-black padding">
        <Container className="header-container">
            <Grid container spacing={2} className="header no-margin">
                <Grid className="menu" xs={3} display="flex"  justifyContent="left" alignItems="center">
                    <Menu/>
                </Grid>
                <Grid className="logo" xs={6} display="flex"  justifyContent="center" alignItems="center">
                    <a href="https://www.sons.co.uk/" title="Sons UK">
                        <img src={logo.src} height="42" alt="logo"/>
                    </a>
                </Grid>
                <Grid className="minicart" xs={3} display="flex" justifyContent="right" alignItems="center">
                    <Minicart/>
                </Grid>
            </Grid>
        </Container>
    </div>
}